import { Routes } from '@angular/router';
import { NotAuthenticatedGuard } from './core/auth/guards/not-authenticated.guard';
import { AuthenticatedGuard } from './core/auth/guards/authenticated.guard';

export const routes: Routes = [
  {
    path: 'auth',
    loadChildren: () => import('./core/auth/auth.routes').then((m) => m.authRoutes),
    canMatch: [NotAuthenticatedGuard],
  },
  {
    path: '',
    loadChildren: () => import('./pages/pages.routes').then((m) => m.pagesRoutes),
    canMatch: [AuthenticatedGuard],
  },
];
